import { BadgeCheck, Check, Clock, MessageCircle, UsersRound } from 'lucide-react';
import { MuralPost } from 'modules/jogador/mural/types';
import { Card } from 'shared/components/ui/Card';
import { Badge } from 'shared/components/ui/Badge';
import { Avatar } from 'shared/components/ui/Avatar';
import { Button } from 'shared/components/ui/Button';

interface PostCardProps {
  post: MuralPost;
  joined: boolean;
  onJoin: () => void;
}

export function PostCard({ post, joined, onJoin }: PostCardProps) {
  return (
    <Card>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Avatar name={post.authorName} size="sm" />
          <div>
            <p className="text-sm font-medium text-ink">{post.authorName}</p>
            <p className="text-xs text-ink-secondary">
              {post.timeAgoLabel}
              {post.levelLabel && ` · ${post.levelLabel}`}
              {post.isOfficial && ' · aviso oficial'}
            </p>
          </div>
        </div>

        {post.kind === 'racha' && <Badge tone="success">RACHA</Badge>}
        {post.kind === 'sem-quadra' && <Badge tone="neutral">SEM QUADRA</Badge>}
        {post.isOfficial && <BadgeCheck className="h-5 w-5 text-primary" aria-label="Aviso oficial da arena" />}
      </div>

      <p className="mt-3 text-sm text-ink">{post.text}</p>

      {post.kind === 'racha' && (
        <>
          <div className="mt-3 flex flex-wrap items-center gap-2 text-xs text-ink-secondary">
            <span className="flex items-center gap-1">
              <Clock className="h-3.5 w-3.5" aria-hidden="true" />
              {post.courtInfo}
            </span>
            <span className="flex items-center gap-1">
              <UsersRound className="h-3.5 w-3.5" aria-hidden="true" />
              {post.spotsLabel}
            </span>
            {post.courtReserved && <Badge tone="success">quadra reservada</Badge>}
          </div>

          <div className="mt-4 flex items-center gap-3">
            <Button className="flex-1" onClick={onJoin} disabled={joined}>
              {joined ? (
                <>
                  <Check className="h-4 w-4" strokeWidth={2.5} aria-hidden="true" />
                  Você entrou
                </>
              ) : post.priceLabel ? (
                `Entrar · ${post.priceLabel}`
              ) : (
                'Confirmar presença'
              )}
            </Button>
            <span className="flex items-center gap-1 text-sm text-ink-secondary">
              <MessageCircle className="h-4 w-4" aria-hidden="true" />
              {post.commentCount}
            </span>
          </div>
        </>
      )}

      {post.kind === 'sem-quadra' && (
        <p className="mt-3 text-xs text-ink-secondary">{post.interestedLabel}</p>
      )}
    </Card>
  );
}
